<template>
  <div>
    <EditPageDialog
      isUpdate
      v-if="isOpen"
      :micrositeId="micrositeId"
      :micrositePage="micrositePage"
      :displayOrder="displayOrder"
      :isOpen="isOpen"
      @close="closeDialog"
    />
    <PrimaryButton class="ml-2" dense shrink light @click.native="openDialog">
      Edit <v-icon>mdi-pencil</v-icon>
    </PrimaryButton>
  </div>
</template>

<script>
import EditPageDialog from "@/views/settings/components/microsites/components/dialogs/PageDialog";
import PrimaryButton from "@/components/common/Button/PrimaryButton";

export default {
  props: {
    micrositeId: String,
    micrositePage: Object,
    displayOrder: Number
  },
  components: {
    EditPageDialog,
    PrimaryButton
  },
  data() {
    return {
      isOpen: false
    };
  },
  methods: {
    openDialog() {
      this.isOpen = true;
    },
    closeDialog() {
      this.isOpen = false;
    }
  }
};
</script>
<style lang="scss"></style>
